module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/1-2-2-d255d6df1b7b414cc0a312e12b34f287.png";